import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmDealersite {
    constructor(config) {
        this.config = config;
    }

    getRootURL() {
        if (this.config.production) {
            return location.origin;
        }
        return "http://dealersite.loc";
    }

    getURL(route) {        
        return this.getRootURL() + route;
    }

    getCurrentUrl() {
        return window.location.href;
    }

    getAccessoriesByVin(vin, successCallback, errorCallback) {
        const route = '/wp-content/plugins/pm-motors-plugin/modules/inventory/php/endpoints/AccessoryEndpoint.php';
        RequestHelper.ajax("GET", this.getURL(route), { vin }, (response) => {
            try {
                let parsed = JSON.parse(response) || {};
                const accessories = Object.fromEntries(
                    Object.entries(parsed).filter(([_, acc]) => acc && acc.enabled)
                );
                successCallback(accessories);
            } catch (e) {
                errorCallback(e);
            }
        }, errorCallback);
    }


    // Method for getting CCPA and TCPA
    getCCPATCPADescriptions(successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL("/index.php?pmGetDescriptions=all"), {}, (response) => {
            // Only PM's WordPress sites have this endpoint. Third-party sites (Dealer Inspire,
            // DDC, embed) answer with their own HTML page, often as a 200: treat that as an
            // error so callers fall back to the default consents. Otherwise consents stayed
            // null and "Finish & Send" crashed on consents.tcpa, so no lead was sent.
            try {
                if (!JSON.parse(response)) throw new Error("empty consents");
            } catch (e) {
                errorCallback(e);
                return;
            }
            successCallback(response);
        }, errorCallback);
    }

    // send twilio message
    sendTwilioMsg(data, successCallback, errorCallback) {
        RequestHelper.ajax("post", this.getURL("/pm/sendTwilio"), data, successCallback, errorCallback);
    }
}
